import React from 'react';
import { PencilIcon } from '@heroicons/react/24/outline';

interface SummaryCardProps {
  title: string;
  children: React.ReactNode;
  editable?: boolean;
  onEdit?: () => void;
  required?: boolean;
  className?: string;
  icon?: React.ReactNode;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  children,
  editable = false,
  onEdit,
  required = false,
  className = '',
  icon
}) => {
  return (
    <div className={`bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow ${className}`}>
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-3">
          {icon && (
            <div className="flex-shrink-0 text-blue-600">
              {icon}
            </div>
          )}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              {title}
              {required && (
                <span className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full">
                  Required
                </span>
              )}
            </h3>
          </div>
        </div>
        {editable && onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className="flex items-center gap-1 text-blue-600 hover:text-blue-700 transition-colors text-sm font-medium min-h-[44px] px-3 py-2"
            aria-label={`Edit ${title}`}
          >
            <PencilIcon className="w-4 h-4" />
            Edit
          </button>
        )}
      </div>
      <div className="text-gray-700">
        {children}
      </div>
    </div>
  );
};

export default SummaryCard;
